import container from 'modules/section-content';
import page from 'page';
import domify from 'domify';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm, PricingPlans } from 'components';
import PricingScripts from 'components/pricingPlans/vendor/index';
import abTesting from 'modules/ab-testing';
import React from 'react';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import aos from 'aos';
import splash from './view/b2e-page.pug';
import metadata from './metadata.json';

const pricingScripts = new PricingScripts();
const metricsLib = window.metricsLib;

export default function register() {
  page(
    '/b2e-identity-management-for-employees',
    render,
    renderPricingPlans,
    pricingScripts.loadScripts,
    pricingScripts.renderPricing,
    pricingScripts.renderFeatures,
    pricingScripts.snippets,
    snippets
  );
  page.exit('/b2e-identity-management-for-employees', unMountApp);
}

function renderPricingPlans(ctx, next) {
  abTesting.executeExperiment('show-pricing-plans', variant => {
    if (variant && variant.name === 'show-pricing-plans') {
      clientRender(
        <PricingPlans btnFooterText="SEE MORE PRICING INFO" />,
        document.querySelector('.solution-page-pricing-plans')
      );
    }
  });

  return next();
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm source="b2e" subject="New lead from B2E page" />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  aos.init();
  contactFormModals();
  return next();
}

function contactFormModals() {
  // Contact Sales Form
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2e-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2e-contact-form', metricsData);
    },
    source: './view/b2e-page'
  };

  /* eslint-env browser */
  document.querySelectorAll('.open-contact-form-modal').forEach(element => {
    element.addEventListener(
      'click',
      () => {
        const salesContactForm = new ContactForm(salesContactFormOptions);
        salesContactForm.show({ includePhoneField: true });
      },
      false
    );
  });
}

function unMountApp(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  unmountComponentAtNode(document.querySelector('.solution-page-pricing-plans'));
  return next();
}



// WEBPACK FOOTER //
// ./src/pages/b2e/b2e.js